/*
 * Edited for You - GA4 計測 (impression / click)
 *
 * 既存 gtag (Google 販売チャネル + ga4-user-id で customer_id 紐付け済) に対し、
 * data-efy-* 属性を持つ要素の表示/クリックをカスタムイベントとして送る。
 *
 *   - クリック: [data-efy-event="efy_xxx"] を委譲リスナーで捕捉 (動的追加要素=collection の
 *     infinite scroll で append される商品カードもカバー)
 *   - 表示:     [data-efy-impression] を IntersectionObserver で1回だけ発火 (efy_impression)
 *
 * 送る params は data-efy-* から組み立てる:
 *   data-efy-surface / data-efy-theme-id / data-efy-collection-handle /
 *   data-efy-product-id / data-efy-theme-name / data-efy-theme-rank / data-efy-n-themes
 *
 * 「在庫切れ→テーマから削除」で後追いできない問題への対処: theme_id と product_id を
 * クリック時点でイベントに焼き込むため、後で商品が売れて削除されても関係は events に残る。
 */
(function () {
  if (window.__efyAnalyticsInit) return;
  window.__efyAnalyticsInit = true;

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }

  function paramsFrom(el) {
    var d = el.dataset;
    var p = {};
    if (d.efySurface) p.surface = d.efySurface;
    if (d.efyThemeId) p.theme_id = d.efyThemeId;
    if (d.efyCollectionHandle) p.collection_handle = d.efyCollectionHandle;
    if (d.efyProductId) p.product_id = d.efyProductId;
    if (d.efyThemeName) p.theme_name = d.efyThemeName;
    if (d.efyThemeRank) p.theme_rank = d.efyThemeRank;
    if (d.efyNThemes) p.n_themes = d.efyNThemes;
    return p;
  }

  // クリック (capture 段階で委譲。後から append される要素にも効く)
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-efy-event]');
    if (!el) return;
    gtag('event', el.dataset.efyEvent, paramsFrom(el));
  }, true);

  // インプレッション (要素ごとに1回)
  function observeImpressions() {
    var nodes = document.querySelectorAll('[data-efy-impression]:not([data-efy-seen])');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (el) {
        el.setAttribute('data-efy-seen', '1');
        gtag('event', 'efy_impression', paramsFrom(el));
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.setAttribute('data-efy-seen', '1');
        io.unobserve(el);
        gtag('event', 'efy_impression', paramsFrom(el));
      });
    }, { threshold: 0.5 });

    nodes.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeImpressions);
  } else {
    observeImpressions();
  }
})();
